import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import CoolerImpoView from "./coolerImpoView";
import CoolerExpoView from "./coolerExpoView";
import CoolerTransitView from "./coolerTransitView";
import "./valeCooler.css";

function ValeCooler() {
  const [awb, setAwb] = useState("");
  const [currentView, setCurrentView] = useState("input");
  const [operacion, setOperacion] = useState("");
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    setAwb(e.target.value);
    setError("");
  };

  const handleSearch = () => {
    if (!awb.trim()) {
      setError("Este campo es obligatorio");
      return;
    }

    if (!operacion) {
      setError("Debes seleccionar una opción de operación");
      return;
    }

    // Validar formato tipo "139-39993671"
    const formatoGuia = /^\d{3}-\d{5,8}$/;

    if (!formatoGuia.test(awb)) {
      setError("El formato de la guía no es válido (ej. 139-39993671)");
      return;
    }

    // Listas de guías válidas por operación
    const guiasImpo = ["123-44447892", "139-39993671"];
    const guiasExpo = ["123-55557777"];
    const guiasTransito = ["321-12341234"];

    // Detectamos el tipo real de la guía
    let tipoReal = "";

    if (guiasImpo.includes(awb)) tipoReal = "impo";
    else if (guiasExpo.includes(awb)) tipoReal = "expo";
    else if (guiasTransito.includes(awb)) tipoReal = "transito";
    else {
      setError("La guía no pertenece a ninguna operación conocida");
      return;
    }

    // Validación: radio button debe coincidir con el tipo de la guía
    if (tipoReal !== operacion) {
      setError("La guía no corresponde al tipo de operación seleccionado");
      return;
    }

    // Todo está bien → mostrar la vista correcta
    setError("");

    if (operacion === "impo") setCurrentView("impo-view");
    if (operacion === "expo") setCurrentView("expo-view");
    if (operacion === "transito") setCurrentView("transito-view");
  };

  // const handleSearch = () => {
  //   if (!awb.trim()) {
  //     setError("Este campo es obligatorio");
  //     return;
  //   }

  //   if (!operacion) {
  //     setError("Debes seleccionar una opción de operación");
  //     return;
  //   }

  //   // Validar formato tipo "139-39993671"
  //   const formatoGuia = /^\d{3}-\d{5,8}$/;

  //   if (!formatoGuia.test(awb)) {
  //     setError("El formato de la guía no es válido (ej. 139-39993671)");
  //     return;
  //   }

  //   setError("");

  //   // Redirigir a la vista correspondiente (sin cambiar URL)
  //   if (operacion === "impo") {
  //     setCurrentView("impo-view");
  //   } else if (operacion === "expo") {
  //     setCurrentView("expo-view");
  //   } else if (operacion === "transito") {
  //     setCurrentView("transito-view");
  //   }
  // };

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>

      <ScrollToTop />

      <div className="container-fluid d-flex justify-content-center">
        <div className="content-wrapper">
          {/* ======================== VISTA PRINCIPAL ======================== */}
          {currentView === "input" && (
            <>
              <div className="row justify-content-center">
                <div className="col-6">
                  <label htmlFor="inputMaster" className="amc-label">
                    Master
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputMaster"
                    onChange={handleInputChange}
                  />
                  {error && <div className="text-danger mt-2">{error}</div>}
                </div>

                <div className="col-6">
                  <div className="d-flex gap-3 mt-4">
                    {["impo", "expo", "transito"].map((op) => (
                      <div className="form-check" key={op}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipoOperacion"
                          id={op}
                          value={op}
                          checked={operacion === op}
                          onChange={(e) => setOperacion(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor={op}>
                          {op.charAt(0).toUpperCase() + op.slice(1)}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="row justify-content-center mt-3">
                <div className="col-12 d-flex justify-content-end">
                  <button className="btnn" onClick={handleSearch}>
                    Buscar
                  </button>
                </div>
              </div>
            </>
          )}

          {/* ======================== VISTA IMPO ======================== */}
          {currentView === "impo-view" && (
            <CoolerImpoView
              awb={awb}
              operacion={operacion}
              onBack={() => setCurrentView("input")}
            />
          )}

          {/* ======================== PLACEHOLDERS (Expo/Transito) ======================== */}
          {currentView === "expo-view" && (
            <CoolerExpoView 
              awb={awb}
              operacion={operacion}
              onBack={() => setCurrentView("input")}
            />
          )}

          {currentView === "transito-view" && (
            <CoolerTransitView 
              awb={awb}
              operacion={operacion}
              onBack={() => setCurrentView("input")}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default ValeCooler;
